import { Modify } from 'types/modify';
import { Header, HeaderFull, ModalWindows, NavigationLink, SanityKeyed } from './studio';

export type RegionSelector = Modify<
  ModalWindows['region'],
  {
    _type?: 'region';
  }
>;

export enum NavigationLinkType {
  page = 'page',
  link = 'link',
  submenu = 'submenu'
}

export enum HeaderBackground {
  white = 'white',
  transparent = 'transparent'
}

export type HeaderNavLink = {
  slug?: {
    current: string;
  };
};

export type HeaderNavigationLink = Modify<
  NonNullable<NavigationLink>,
  {
    type: NavigationLinkType;
    navPage?: HeaderNavLink;
  }
>;

export type HeaderNavigation = Modify<
  NonNullable<Header['navigation']>[number],
  {
    navPage?: HeaderNavLink;
    navSubmenu?: Array<SanityKeyed<HeaderNavigationLink>>;
  }
>;

// TODO: This should be removed in favor of using the real types returned from
// our Sanity queries.
export type HeaderResult = Modify<
  Header,
  {
    navigation: Array<SanityKeyed<HeaderNavigation>>;
    navV2: Array<SanityKeyed<HeaderNavigation>>;
    regionSelector?: RegionSelector;
  }
>;

export type HeaderSection = SanityKeyed<HeaderFull>;
